import { useEffect, useState } from "react";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import Hero from "../components/Hero";

function Home({ cart, addToCart, decreaseQuantity }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_API}/api/products`);
      setProducts(data);
    };
    fetchProducts();
  }, []);

  return (
    <div>
      <Hero />
      <div className="mb-12">
        <h2 className="text-3xl font-extrabold text-slate-900 mb-8 flex items-center">
          Featured Products
          <div className="ml-4 h-1 flex-grow bg-slate-100 rounded"></div>
        </h2>
        {products.length === 0 ? (
          <div className="text-center text-slate-500 py-10">Loading products...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {products.map((product) => {
              const cartItem = cart.find((x) => x._id === product._id);
              const qty = cartItem ? cartItem.qty : 0;
              return (
                <ProductCard 
                  key={product._id} 
                  product={product} 
                  qty={qty} 
                  addToCart={addToCart} 
                  decreaseQuantity={decreaseQuantity} 
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
